import axios from 'axios';
import API_V2_URL from '@/constants/API_V2_URL';
import headers from '@/constants/headers';

axios.defaults.headers.common.Authorization = `Bearer ${ headers.access_token }`;

const InterestedsService = {
  search(q, interestedType) {
    return axios.get(`${ API_V2_URL() }/interesteds/interesteds/search?interested_type=${ interestedType }&q=${ q }`);
  },
  destroy(interestedId) {
    return axios.delete(`${ API_V2_URL() }/interesteds/interesteds/${interestedId}`);
  },
};

export default InterestedsService;



// WEBPACK FOOTER //
// ./src/services/InterestedsService.js